import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { TipoArquivo, TipoArquivoAnexo } from 'src/app/models/enum';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { AnexoModel } from '../../../dominio/anexo-model';
import { TipoAnexoModel } from "../../../dominio/tipo-anexo-model";
import { QueryFilterService } from "../../services/query-filter-service";
import { TipoAnexoService } from "../../services/tipo-anexo.service";
import { TipoSituacaoCadastral } from "src/app/dominio/enums";
import swal from "sweetalert2";
import { GlobalService } from "src/app/services/global.service";

type DisplayMode = 'list' | 'preview';

@Component({
  selector: 'app-anexo-viewer-v2',
  templateUrl: './anexo-viewer-v2.component.html',
  styleUrls: ['./anexo-viewer-v2.component.scss']
})
export class AnexoViewerV2Component implements OnInit, OnChanges, AfterViewInit {
  @Input() somenteLeitura: boolean = false;
  @Input() podeValidar: boolean = false;
  @Input() anexos: AnexoModel[] = [];

  @Output() aoCriar = new EventEmitter<AnexoModel[]>();
  @Output() aoAtualizar = new EventEmitter<AnexoModel>();
  @Output() aoExcluir = new EventEmitter<AnexoModel>();
  @Output() aoValidar = new EventEmitter<AnexoModel>();

  anexosInterno: AnexoModel[] = [];
  displayMode: DisplayMode = 'list';
  tiposAnexos: TipoAnexoModel[] = [];
  usaClassificacao: boolean = false;
  simNaoModel = [{ nome: 'Sim', valor: true }, { nome: 'Não', valor: false }];

  adicionando: boolean = false;
  editando: boolean = false;

  anexoSelecionado: AnexoModel;
  indexAnexo = 0;
  mostrarPDF = false;
  integrador: boolean = false;

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private arquivoService: ArquivoService,
    private utilitarioService: UtilitarioService,
    private queryFilterService: QueryFilterService,
    private tipoAnexoServiceV2: TipoAnexoService,
    private globalService: GlobalService
  ) { }

  async ngOnInit() {
    this.integrador = await this.globalService.integrador();

    this.buscaTiposAnexos();
  }

  ngAfterViewInit() {
    this.configurarPreview();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.anexos && changes.anexos.currentValue !== changes.anexos.previousValue) {
      this.configurarAnexos();
      this.configurarPreview();
    }
  }

  configurarAnexos() {
    this.anexosInterno = this.anexos.map(p => {
      const obj = Object.assign({}, p);

      if (!obj.tipoAnexo) {
        obj.tipoAnexo = {
          id: 0,
          nome: 'Não Classificado',
        }
      }

      return obj;
    });
  }

  buscaTiposAnexos() {
    this.tiposAnexos = [];
    this.carregandoService.mostra("buscaTiposAnexos");

    const queryFilter = this.queryFilterService.getQueryBuilder()
      .addCondition("situacao", "=", TipoSituacaoCadastral.Ativo)
      .build();

    this.tipoAnexoServiceV2.buscarTodos(queryFilter).subscribe(
      (tiposAnexos) => {
        this.tiposAnexos = tiposAnexos.results;
        this.usaClassificacao = this.tiposAnexos.length > 0;
      },
      (erro) => {
        this.carregandoService.esconde("buscaTiposAnexos");
        this.notificacaoService.erro(erro);
      },
      () => {
        this.carregandoService.esconde("buscaTiposAnexos");
      }
    );
  }

  mudarModoVisualizacao(modo: DisplayMode) {
    this.displayMode = modo;
  }

  cadastrarAnexo() {
    this.adicionando = true;
  }

  editarAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    anexo.editando = true;
    this.editando = true;
  }

  excluirAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    swal({
      title: 'Atenção!!',
      text: 'Essa operação não poderá ser desfeita. Deseja realmente excluir esse anexo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.aoExcluir.emit(anexo);
      }
    });
  }

  baixarAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    this.carregandoService.mostra('baixarAnexo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.Anexo).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, anexo.arquivo);
      this.carregandoService.esconde('baixarAnexo');
    }, (erro) => {
      this.carregandoService.esconde('baixarAnexo');
      this.notificacaoService.erro(erro);
    });
  }

  validarAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    swal({
      title: 'Atenção!!',
      text: 'Após validado não será possível editar ou excluir o anexo. Deseja continuar?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.aoValidar.emit(anexo);
      }
    });
  }

  salvarAnexo(idAnexo: number) {
    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    anexo.editando = false;

    this.editando = false;
    this.aoAtualizar.emit(anexo);
  }

  cancelarAnexo(idAnexo?: number) {
    this.adicionando = false;
    this.editando = false;

    if (!idAnexo) {
      return;
    }

    const anexo = this.anexosInterno.find(x => x.id === idAnexo);

    if (!anexo) {
      return;
    }

    const anexoOriginal = this.anexos.find(x => x.id === idAnexo);

    anexo.descricao = anexoOriginal.descricao;

    if (anexoOriginal.tipoAnexo) {
      anexo.tipoAnexo.id = anexoOriginal.tipoAnexo.id || 0;
      anexo.tipoAnexo.nome = anexoOriginal.tipoAnexo.nome || "Não Classificado";
    } else {
      anexo.tipoAnexo = { id: 0, nome: 'Não Classificado' }
    }

    anexo.editando = false;
  }

  onFileDropped(event: any) {
    this.salvaListaAnexos(event);
  }

  fileBrowseHandler(event: any) {
    this.salvaListaAnexos(event.target.files);
  }

  salvaListaAnexos(files: Array<File>) {
    const anexos: AnexoModel[] = [];

    for (const item of files) {
      const anexo: AnexoModel = {
        descricao: item.name,
        uploadedFile: item,
      }

      anexos.push(anexo);
    }

    this.adicionando = false;
    this.aoCriar.emit(anexos);
  }

  configurarPreview() {
    this.indexAnexo = 0;

    this.selecionarAnexoPreview();
  }

  selecionarAnexoPreview() {
    if (this.anexosInterno && this.anexosInterno.length > 0) {
      this.anexoSelecionado = this.anexosInterno[this.indexAnexo];

      this.exibirAnexoPreview(this.anexoSelecionado);
    } else {
      this.anexoSelecionado = undefined;
    }
  }

  exibirAnexoPreview(anexo: AnexoModel) {
    this.mostrarPDF = false;

    if (!anexo.carregado) {
      this.carregandoService.mostra('visualizarArquivo');
      this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.Anexo).subscribe(arq => {
        anexo.carregado = true;

        if (this.utilitarioService.ePDF(anexo.arquivo)) {
          anexo.tipoArquivo = TipoArquivoAnexo.Pdf;
          anexo.blobArquivo = arq;

          setTimeout(() => {
            this.mostrarPDF = true;
          }, 100);
        } else if (this.utilitarioService.eImagem(anexo.arquivo)) {
          anexo.tipoArquivo = TipoArquivoAnexo.Imagem;

          const reader = new FileReader();

          reader.onloadend = () => {
            anexo.srcArquivo = reader.result;
          };

          reader.readAsDataURL(arq);
        } else {
          anexo.tipoArquivo = TipoArquivoAnexo.Outros;
        }

        this.carregandoService.esconde('visualizarArquivo');
      }, (erro) => {
        this.carregandoService.esconde('visualizarArquivo');
        this.notificacaoService.erro(erro);
      });
    } else {
      if (anexo.tipoArquivo === TipoArquivoAnexo.Pdf) {
        this.mostrarPDF = true;
      }
    }
  }

  anexoAnterior() {
    if (this.indexAnexo - 1 >= 0) {
      this.indexAnexo--;
      this.selecionarAnexoPreview();
    }
  }

  proximoAnexo() {
    if (this.indexAnexo + 1 < this.anexosInterno.length) {
      this.indexAnexo++;
      this.selecionarAnexoPreview();
    }
  }
}
